import React, { useState, useEffect } from "react";
import BoatType from "./BoatTypePage";
import BoatDetailsPage from "./BoatDetailsPage";
import InsuranceOptionsPage from "./InsuranceOptionsPage";
import PersonalDetailsPage from "./PersonalDetailsPage";
import ConfirmationPage from "./ConfirmationPage";
import ProgressBar from "./ProgressBar";
import steps from "../constants/steps";

const Verzekeringstool = ({ initialBoatType }) => {
  const [currentStep, setCurrentStep] = useState(initialBoatType ? 1 : 0);
  const [formData, setFormData] = useState(
    initialBoatType ? { boatType: initialBoatType } : {}
  );

  const handleNext = (data) => {
    setFormData({ ...formData, ...data });
    setCurrentStep((prevStep) => prevStep + 1);
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 50);
  };

  const handleBack = () => {
    setCurrentStep((prevStep) => prevStep - 1);
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 50);
  };

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return <BoatType onNext={handleNext} formData={formData} />;
      case 1:
        return (
          <BoatDetailsPage
            onNext={handleNext}
            onBack={handleBack}
            formData={formData}
          />
        );
      case 2:
        return (
          <InsuranceOptionsPage
            onNext={handleNext}
            onBack={handleBack}
            formData={formData}
          />
        );
      case 3:
        return (
          <PersonalDetailsPage
            onNext={handleNext}
            onBack={handleBack}
            formData={formData}
          />
        );
      case 4:
        return <ConfirmationPage formData={formData} onBack={handleBack} />;
      default:
        return <BoatType onNext={handleNext} />;
    }
  };

  return (
    <div className="verzekeringstool">
      <ProgressBar steps={steps} currentStep={currentStep} />
      <div className="step-container">{renderStep()}</div>
    </div>
  );
};

export default Verzekeringstool;
